import HeadLine from "../../components/HeadLine/Headline"

const Admin = () => {
  return <HeadLine>Správcovská sekcia</HeadLine>
}

export default Admin
